import React from 'react'
import { Link } from 'react-router-dom'

export default function SolutionsPractices() {
  return (
    <section className="section light" style={{ minHeight: '70vh' }}>
      <h2>Practices &amp; Solo Providers</h2>
      <p className="lead muted">
        ATUUNE's routing and continuity infrastructure is built primarily for health plans and provider
        organizations — but solo providers and individual practices remain fully supported on the same
        platform.
      </p>

      <div className="section-block">
        <div className="section-head"><h2>For group practices &amp; clinics</h2></div>
        <p className="lead muted">
          A clear, calm view into how your patients are doing: who might be drifting away, who's
          approaching that important fourth session, and where your team has room to take on more.
        </p>
        <div className="cards">
          <div className="card"><h3>People who may need support</h3><p>A clearer view of who may benefit from a check-in.</p></div>
          <div className="card"><h3>Where care may be slowing down</h3><p>Notice patterns earlier and respond sooner.</p></div>
          <div className="card"><h3>Your provider team at a glance</h3><p>Capacity, how well routed patients are sticking, and caseload — all in one place.</p></div>
          <div className="card"><h3>Continuity visibility</h3><p>See who's engaging, who may need support, and how care is progressing.</p></div>
        </div>
        <div className="actions" style={{ marginTop: 20 }}>
          <Link to="/signup/practice">Sign up free</Link>
          <Link className="secondary outline-dark" to="/login">Sign in to your dashboard</Link>
        </div>
      </div>

      <div className="section-block">
        <div className="section-head"><h2>For solo providers</h2></div>
        <p className="lead muted">
          Less guesswork about who you're meeting, and a clearer sense of who might need a check-in before
          their next session.
        </p>
        <div className="cards">
          <div className="card"><h3>Better-fit patients</h3><p>Patients routed to you based on what actually fits — not just availability.</p></div>
          <div className="card"><h3>Clearer routing reasons</h3><p>Every patient you're routed comes with a plain-language reason — never an unexplained score.</p></div>
          <div className="card"><h3>Reduce early dropout</h3><p>Better-fit patients are more likely to stay engaged through the sessions that matter most, strengthening continuity.</p></div>
        </div>
        <div className="actions" style={{ marginTop: 20 }}>
          <Link to="/signup/provider">Sign Up Free</Link>
          <Link className="secondary outline-dark" to="/login">Sign In</Link>
        </div>
      </div>
    </section>
  )
}
